import gql from 'graphql-tag'

export const ALL_INTERIMS = gql`
  query{
    allInterimaires{
      totalCount
      edges{
        node{
          nom
          prenom
          email
          id
          numss
          adresse
          createdAt
          updatedAt
          telephone
          email
          actif
          salutation
          dateNaiss
          lieuNaiss
          departementNaiss
          nationalite
        }
      }
    }
  }
`

export const ALL_ACTIVES_INTERIMS = gql`
  query{
    allInterimaires(
      orderBy: NOM_ASC
      condition: {
        actif: true
      }
    ){
      totalCount
      nodes{
        nom
        prenom
        email
        id
        numss
        adresse
        createdAt
        updatedAt
        telephone
        email
        actif
        salutation
        dateNaiss
        lieuNaiss
        departementNaiss
        nationalite
      }
    }
  }
`
export const CREATE_INTERIMAIRE = gql`
mutation($nom: String!, $prenom: String, $numss: String,
  $adresse: String, $telephone: String, $email: String, $actif: Boolean,
   $salutation: String,  $dateNaiss: Date, $departementNaiss: String, $nationalite: String, $lieuNaiss: String){
    createInterimaire(input:{
      interimaire:{
        nom: $nom
        prenom: $prenom
        numss: $numss
        adresse: $adresse
        telephone: $telephone
        email: $email
        actif: $actif
        salutation: $salutation
        dateNaiss: $dateNaiss
        departementNaiss: $departementNaiss
        lieuNaiss: $lieuNaiss
        nationalite: $nationalite
      }
    }){
      interimaire{
        id
        nom
        prenom
      }
    }
  }
  `
export const DELETE_INTERIM = gql`
  mutation ($id: Int!){
    deleteInterimaireById(
      input: {
        id: $id
      }
    ) {
      deletedInterimaireId
      interimaire {
        nom
      }
    }
  }
  `
export const UPDATE_INTERIM = gql`
mutation($id: Int!, $nom: String, $prenom: String, $numss: String,
  $adresse: String, $telephone: String, $email: String, $actif: Boolean,
   $salutation: String,  $dateNaiss: Date, $departementNaiss: String, $nationalite: String, $lieuNaiss: String){
    updateInterimaireById(input:{
      id: $id
      interimairePatch:{
        nom: $nom
        prenom: $prenom
        numss: $numss
        adresse: $adresse
        telephone: $telephone
        email: $email
        actif: $actif
        salutation: $salutation
        dateNaiss: $dateNaiss
        departementNaiss: $departementNaiss
        lieuNaiss: $lieuNaiss
        nationalite: $nationalite
      }
    }){
      interimaire{
        id
        nom
        prenom
        numss
        adresse
        telephone
        email
        actif
        salutation
        dateNaiss
        departementNaiss
        lieuNaiss
        nationalite
      }
    }
  }
  `
export const INTERIMAIRE_BY_ID = gql`
query($id: Int!){
  interimaireById(id: $id)
  {
      id
      nom
      prenom
      numss
      adresse
      telephone
      email
      actif
      salutation
      dateNaiss
      departementNaiss
      lieuNaiss
      nationalite
  }
}
`



// WEBPACK FOOTER //
// ./src/constants/interim.js